import { FC, ReactNode } from "react";
import clsx from "clsx";
import S from "./index.module.scss";

interface ITitle {
  variant?: "black" | "white";
  children: ReactNode;
  className?: string;
}

const Title: FC<ITitle> = ({ variant = "black", className, ...props }) => {
  return <h1 className={clsx(S.title, S[variant], className)} {...props} />;
};

export default Title;
